import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ChangeDetectionStrategy
} from "@angular/core";
import { nameof } from "ts-simple-nameof";
import { LorenFieldTypes } from "../../../../../../shared/modules/loren-entity-form-card/enums/loren-field-types.enum";
import { LorenEntityFormModel } from "../../../../../../shared/modules/loren-entity-form-card/interfaces/loren-entity-form-model.interface.ts";
import { LorenUserInfo } from "../../../../../../shared/interfaces/loren-user-info.interface";
import { LorenFormSubmission } from "../../../../../../shared/modules/loren-entity-form-card/interfaces/loren-form-submission.interface";
import { RegexPatterns } from "../../../../../../shared/constants/regex-patterns.constants";
import { LorenInputTypes } from "../../../../../../shared/modules/loren-entity-form/components/loren-entity-form-field/constants/loren-input-types.constants";
import { MatCardModule } from "@angular/material/card";
import { CommonModule } from "@angular/common";
import { MatMenuModule } from "@angular/material/menu";
import { MatIconModule } from "@angular/material/icon";
import { LorenKeyValueComponent } from "../../../../../../shared/modules/loren-key-value-control/loren-key-value/loren-key-value.component";
import { LorenEntityFormModule } from "../../../../../../shared/modules/loren-entity-form/loren-entity-form.module";
import { TranslocoModule } from "@jsverse/transloco";
import { MatButton, MatIconButton } from "@angular/material/button";

@Component({
  imports: [
    CommonModule,
    MatCardModule,
    MatMenuModule,
    MatIconModule,
    MatIconButton,
    LorenKeyValueComponent,
    LorenEntityFormModule,
    TranslocoModule,
    MatButton
  ],
  selector: "loren-user-profile-details",
  standalone: true,
  styleUrls: ["./loren-user-profile-details.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "./loren-user-profile-details.component.html",
})
export class LorenUserProfileDetailsComponent implements OnChanges {
  @Input() userInfo: LorenUserInfo;
  @Output() userInfoUpdated = new EventEmitter<LorenUserInfo>();

  isEditingUserDetails: boolean;
  userDetailsFormModel: LorenEntityFormModel;

  ngOnChanges(): void {
    this.buildUserDetailsFormGroup();
  }

  toggleIsEditingUserDetails() {
    this.isEditingUserDetails = !this.isEditingUserDetails;
    this.buildUserDetailsFormGroup();
  }

  handleFormSubmit(formSubmission: LorenFormSubmission) {
    if (formSubmission.valid) {
      this.toggleIsEditingUserDetails();
      if (formSubmission.dirty) {
        this.userInfoUpdated.emit(this.preparePayload(formSubmission));
      }
    }
  }

  private preparePayload(formSubmission: LorenFormSubmission): LorenUserInfo {
    return {
      id: this.userInfo.id,
      email: formSubmission.value[nameof<LorenUserInfo>((u) => u.email)],
      firstName:
        formSubmission.value[nameof<LorenUserInfo>((u) => u.firstName)],
      lastName: formSubmission.value[nameof<LorenUserInfo>((u) => u.lastName)],
      username: formSubmission.value[nameof<LorenUserInfo>((u) => u.username)],
    };
  }

  private buildUserDetailsFormGroup() {
    this.userDetailsFormModel = {
      formName: "user.edit_user_details_title",
      formFields: [
        {
          name: nameof<LorenUserInfo>((u) => u.firstName),
          label: "user.first_name",
          value: this.userInfo.firstName,
          formControlType: LorenFieldTypes.INPUT,
          validator: {
            required: true,
            minLength: 2,
            maxLength: 50,
          },
          options: [],
        },
        {
          name: nameof<LorenUserInfo>((u) => u.lastName),
          label: "user.last_name",
          value: this.userInfo.lastName,
          formControlType: LorenFieldTypes.INPUT,
          validator: {
            required: true,
            minLength: 2,
            maxLength: 50,
          },
          options: [],
        },
        {
          name: nameof<LorenUserInfo>((u) => u.username),
          label: "user.username",
          value: this.userInfo.username,
          formControlType: LorenFieldTypes.INPUT,
          validator: {
            required: true,
            minLength: 4,
            maxLength: 50,
          },
          options: [],
        },
        {
          name: nameof<LorenUserInfo>((u) => u.email),
          label: "user.email",
          value: this.userInfo.email,
          formControlType: LorenFieldTypes.INPUT,
          inputType: LorenInputTypes.EMAIL,
          validator: {
            required: true,
            minLength: 6,
            maxLength: 255,
            pattern: RegexPatterns.EMAIL,
          },
          hint: "john.doe@example.com",
          options: [],
        },
      ],
    };
  }
}
